import * as React from 'react';
import { useCreatePayoutAccountMutation } from './mutations/use-create-payout-account.mutation';
import { useForm, useStore } from '@tanstack/react-form';
import { PayoutMethod } from '@/types/api/payout-account';
import { createPayoutAccountSchema } from '@/validators/create-payout-account.schema';

export function useCreatePayoutAccountForm(onSuccess: () => void) {
  const mutation = useCreatePayoutAccountMutation();

  const form = useForm({
    defaultValues: {
      payoutMethod: PayoutMethod.BankTransfer,
      swishNumber: '',
      selectionId: '',
    },
    validators: { onSubmit: createPayoutAccountSchema },
    onSubmit: ({ value }) => {
      const { selectionId, swishNumber, payoutMethod } = value;

      mutation.mutate(
        {
          payoutMethod,
          payoutMethodData: { selectionId: selectionId || undefined, swishNumber: swishNumber || undefined },
        },
        { onSuccess },
      );
    },
  });

  const payoutMethod = useStore(form.store, (state) => state.values.payoutMethod);

  React.useEffect(() => {
    if (payoutMethod === PayoutMethod.BankTransfer) {
      form.setFieldMeta('swishNumber', (state) => ({ ...state, errorMap: {} }));
    }
    if (payoutMethod === PayoutMethod.Swish) {
      form.setFieldMeta('selectionId', (state) => ({ ...state, errorMap: {} }));
    }
  }, [payoutMethod, form]);

  return form;
}
